<template>
  <section class="roomCards">
    <div class="roomCards__container">
      <div
        class="roomCards__roomName"
        :style="{ borderLeft: color[room?.platformType] }"
        tabindex="0"
        :aria-describedby="showPlatformTooltip && platformTooltipText(roomsPlatformType) ? platformTooltipId : null"
        @click="handlePlatformTap">
        <p>{{ room.roomName }}</p>
        <ToolTip v-if="showPlatformTooltip && platformTooltipText(roomsPlatformType)" :id="platformTooltipId" role="tooltip" :text="platformTooltipText(roomsPlatformType)" variant="down" />
      </div>
      <div class="roomCards__turnContainer" v-if="morning.length">
        <div :class="['roomCards__turn', ind.register ? 'r' : 'm']" v-for="(ind, idx) in morning" :key="getUserIdentifier(ind, idx, 'morning')">
          <p class="roomCards__text roomCards__text__Room">MAÑANA</p>
          <template v-if="ind.register">
            <router-link class="roomCards__link" :to="getLink(ind._id)" target="_blank">
              <div class="roomCards__avatarWrapper" @click="handleAvatarTap(getUserIdentifier(ind, idx, 'morning'), ind, $event)">
                <avatar :class="`roomCards__imgModel roomCards__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
                <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, 'morning'), ind)" text="Free" variant="down" />
              </div>
              <p class="roomCards__text">{{ ind.artisticName }}</p>
            </router-link>
          </template>
          <template v-else>
            <div class="roomCards__avatarWrapper" @click="handleAvatarTap(getUserIdentifier(ind, idx, 'morning'), ind, $event)">
              <avatar :class="`roomCards__imgModel roomCards__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
              <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, 'morning'), ind)" :text="platformTooltipText(ind?.platformType)" variant="down" />
            </div>
            <p class="roomCards__text">{{ ind.artisticName }}</p>
          </template>
        </div>
      </div>
      <div :class="`roomCards__else roomCards__text roomCards__text__dis roomCard__else--${room.isEnable !== false ? true : false}`" v-else>
        <p class="roomCards__text roomCards__text__Room">MAÑANA</p>
        <p class="roomCards__text">{{ room.isEnable !== false ? "Habilitada" : "Deshabilitada" }}</p>
      </div>
      <div class="roomCards__turnContainer" v-if="late.length">
        <div :class="['roomCards__turn', ind.register ? 'r' : 'l']" v-for="(ind, idx) in late" :key="getUserIdentifier(ind, idx, 'late')">
          <p class="roomCards__text roomCards__text__Room">TARDE</p>
          <template v-if="ind.register">
            <router-link class="roomCards__link" :to="getLink(ind._id)" target="_blank">
              <div class="roomCards__avatarWrapper" @click="handleAvatarTap(getUserIdentifier(ind, idx, 'late'), ind, $event)">
                <avatar :class="`roomCards__imgModel roomCards__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
                <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, 'late'), ind)" text="Free" variant="down" />
              </div>
              <p class="roomCards__text">{{ ind.artisticName }}</p>
            </router-link>
          </template>
          <template v-else>
            <div class="roomCards__avatarWrapper" @click="handleAvatarTap(getUserIdentifier(ind, idx, 'late'), ind, $event)">
              <avatar :class="`roomCards__imgModel roomCards__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
              <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, 'late'), ind)" text="Free" variant="down" />
            </div>
            <p class="roomCards__text">{{ ind.artisticName }}</p>
          </template>
        </div>
      </div>
      <div :class="`roomCards__else roomCards__text roomCards__text__dis roomCard__else--${room.isEnable !== false ? true : false}`" v-else>
        <p class="roomCards__text roomCards__text__Room">TARDE</p>
        <p class="roomCards__text">{{ room.isEnable !== false ? "Habilitada" : "Deshabilitada" }}</p>
      </div>
      <div class="roomCards__turnContainer" v-if="nigth.length">
        <div :class="['roomCards__turn', ind.register ? 'r' : 'n']" v-for="(ind, idx) in nigth" :key="getUserIdentifier(ind, idx, 'nigth')">
          <p class="roomCards__text roomCards__text__Room">NOCHE</p>
          <template v-if="ind.register">
            <router-link class="roomCards__link" :to="getLink(ind._id)" target="_blank">
              <div class="roomCards__avatarWrapper" @click="handleAvatarTap(getUserIdentifier(ind, idx, 'nigth'), ind, $event)">
                <avatar :class="`roomCards__imgModel roomCards__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
                <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, 'nigth'), ind)" text="Free" variant="down" />
              </div>
              <p class="roomCards__text">{{ ind.artisticName }}</p>
            </router-link>
          </template>
          <template v-else>
            <div class="roomCards__avatarWrapper" @click="handleAvatarTap(getUserIdentifier(ind, idx, 'nigth'), ind, $event)">
              <avatar :class="`roomCards__imgModel roomCards__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
              <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, 'nigth'), ind)" text="Free" variant="down" />
            </div>
            <p class="roomCards__text">{{ ind.artisticName }}</p>
          </template>
        </div>
      </div>
      <div :class="`roomCards__else roomCards__text roomCards__text__dis roomCard__else--${room.isEnable !== false ? true : false}`" v-else>
        <p class="roomCards__text roomCards__text__Room">NOCHE</p>
        <p class="roomCards__text">{{ room.isEnable !== false ? "Habilitada" : "Deshabilitada" }}</p>
      </div>
    </div>
  </section>
</template>

<script>
  import ToolTip from "@/components/atoms/ToolTip.vue";
  import { mapGetters } from "vuex";
  export default {
    name: "mobileRoomCard",
    props: {
      room: Array[Object],
    },
    components: { ToolTip },
    data() {
      return {
        turns: ["morning", "late", "nigth"],
        morning: [],
        late: [],
        nigth: [],
        rooms: this.room,
        color: { both: "solid 4px #EF9E25", free: "solid 4px #7f19ad", private: "#fff" },
        showPlatformTooltip: false,
        hoveredFreeUserId: null,
      };
    },
    computed: {
      roomsPlatformType() {
        return this.rooms?.platformType || this.room?.platformType;
      },
      platformTooltipId() {
        const id = this.rooms?._id || this.room?._id || this._uid;
        return `mobileRoomCard-platform-tooltip-${id}`;
      },
      ...mapGetters("applications", {
        getAppByName: "getAppByName",
      }),
    },
    methods: {
      platformTooltipText(platformType) {
        if (!Array.isArray(platformType) || platformType.length === 0) return "";

        const map = {
          free: "Free",
          private: "Privada",
          group: "Grupal",
        };

        const hasFree = platformType.includes("free");
        const hasPrivate = platformType.includes("private");

        if (hasFree && hasPrivate) return "Free / Priv";
        if (platformType.length === 1) return map[platformType[0]] || "";

        return "";
      },
      getLink(id) {
        const app = this.getAppByName("website");
        const response = `/nav?to=${app.link}/models/?filter=hired%26record=${id}%23app`;
        return response;
      },
      getUser(ind) {
        return { ...ind, role: "model" };
      },
      getUserIdentifier(user, idx, shift) {
        return user?._id || user?.id || `${shift}-${idx}`;
      },
      handlePlatformTap(event) {
        if (!this.platformTooltipText(this.roomsPlatformType)) return;
        event.preventDefault();
        event.stopPropagation();
        const shouldShow = !this.showPlatformTooltip;
        this.closeMobileTooltips();
        if (shouldShow) {
          this.showPlatformTooltip = true;
        }
      },
      handleAvatarTap(identifier, user, event) {
        if (!this.isFreeUser(user)) return;
        event.preventDefault();
        event.stopPropagation();
        const shouldShow = this.hoveredFreeUserId !== identifier;
        this.closeMobileTooltips();
        if (shouldShow) {
          this.hoveredFreeUserId = identifier;
        }
      },
      shouldShowFreeTooltip(identifier, user) {
        return this.isFreeUser(user) && this.hoveredFreeUserId === identifier;
      },
      isFreeUser(user) {
        const allowed = ["free", "group"];
        return Array.isArray(user?.platformType) && user.platformType.some((t) => allowed.includes(t));
      },
      handleGlobalTap(event) {
        if (!this.$el || this.$el.contains(event.target)) return;
        this.closeMobileTooltips();
      },
      closeMobileTooltips() {
        this.showPlatformTooltip = false;
        this.hoveredFreeUserId = null;
      },
      getPlatformClass(pt) {
        if (!Array.isArray(pt) || pt.length === 0) return "";
        if (pt.includes("free") && pt.includes("private")) return "both";
        return pt[0];
      },
    },
    beforeMount: async function () {
      this.room.users.forEach((e) => {
        if (e.workShift.name === "morning") this.morning.push(e);
        if (e.workShift.name === "late") this.late.push(e);
        if (e.workShift.name === "night") this.nigth.push(e);
      });
    },
    mounted() {
      if (typeof document === "undefined") return;
      document.addEventListener("touchstart", this.handleGlobalTap);
      document.addEventListener("click", this.handleGlobalTap);
    },
    beforeDestroy() {
      if (typeof document === "undefined") return;
      document.removeEventListener("touchstart", this.handleGlobalTap);
      document.removeEventListener("click", this.handleGlobalTap);
    },
  };
</script>
<style lang="scss">
  .roomCards {
    &__container {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1px;
    }
    &__text {
      font-weight: bold;
      margin: 0 5px 0 5px;
      margin-top: 5px;
      font-size: 12px;
      text-align: center;

      &__Room {
        display: flex;
        padding: 0 5px;
        border-right: #00000052 2px solid;
        width: 70px;
        font-weight: bold;
      }
      &__dis {
        display: flex;
        color: gray;
      }
    }
    &__roomName {
      margin: 20px 0 5px 0;
      text-align: center;
      box-shadow: $dshadow;
      color: $primary-color;
      text-transform: uppercase;
      font-weight: bold;
      padding: 8px;
      position: relative;
      cursor: default;

      @include bordered-box();
    }
    &__turn {
      display: flex;
      align-items: center;
      padding: 5px 10px;
      width: auto;
      height: 42px;
      margin: 5px 0;
    }
    &__else {
      text-align: center;
      padding: 10px;
      width: auto;
      margin: 5px 0;
      &--true {
        background-color: $green-color;
        color: $camouflage-green;
      }
      &--false {
        background-color: $ghost;
        color: $black;
      }
    }
    &__link {
      display: flex;
      width: 100%;
      color: black;
    }
    .m {
      background-color: $blue-primary;
    }
    .l {
      background-color: $yellow-color;
    }
    .n {
      background-color: $gray-color;
    }
    .r {
      background-color: rgba(0, 0, 0, 0.043);
      & :hover {
        text-decoration: none;
      }
    }
    &__else,
    &__roomName,
    &__turn {
      width: auto;
      border-radius: 5px;
    }
    &__imgModel {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      border: solid white 2px;
      margin: 3px 2px;
      margin-right: 5px;
      &-free {
        border: solid 2px $free;
      }
    }
    &__avatarWrapper {
      position: relative;
      display: flex;
      align-items: center;
    }
    @media screen and (min-width: 420px) {
      &__imgModel {
        width: 30px;
        height: 30px;
      }
      &__text {
        font-size: 15px;
        &__Room {
          width: 25%;
          max-width: 100px;
        }
      }
    }
  }
</style>
